import React, {
  useEffect,
  useRef,
  useState,
} from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";


export default function MailFolderCreateDialog({
  open,
  saving = false,
  initialName = "",
  eyebrow = "Dossiers personnalisés",
  title = "Créer un dossier",
  description = "Donnez un nom clair au dossier pour classer vos messages.",
  submitLabel = "Créer le dossier",
  savingLabel = "Création…",
  testIdPrefix = "mail-folder-create",
  requireChange = false,
  onClose,
  onSubmit,
}) {
  const [
    name,
    setName,
  ] = useState("");
  const inputRef = useRef(null);

  useEffect(
    () => {
      if (!open) {
        setName("");
        return;
      }

      setName(initialName);

      window.setTimeout(
        () => inputRef.current?.focus(),
        0
      );
    },
    [
      open,
      initialName,
    ]
  );

  if (!open) {
    return null;
  }

  const cleanName = name.trim();
  const unchanged =
    requireChange
    && cleanName === initialName.trim();

  function submit(event) {
    event.preventDefault();

    if (
      !cleanName
      || unchanged
      || saving
    ) {
      return;
    }

    onSubmit(cleanName);
  }

  return (
    <div
      className="fixed inset-0 z-[160] flex items-center justify-center acta-modal-overlay p-3 sm:p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby={`${testIdPrefix}-title`}
      data-testid={`${testIdPrefix}-dialog`}
      onClick={() => {
        if (!saving) {
          onClose?.();
        }
      }}
    >
      <form
        className="acta-modal-surface w-full rounded-3xl bg-[var(--do-bg-solid)] p-5 shadow-2xl sm:max-w-md sm:p-6"
        onSubmit={submit}
        onClick={(event) =>
          event.stopPropagation()
        }
      >
        <div className="label-eyebrow">
          {eyebrow}
        </div>

        <h2
          id={`${testIdPrefix}-title`}
          className="mt-1 font-heading text-xl font-black text-[var(--do-ink)]"
        >
          {title}
        </h2>

        <p className="mt-2 text-sm leading-6 text-[var(--do-muted)]">
          {description}
        </p>

        <label className="mt-5 block">
          <span className="mb-2 block text-sm font-black text-[var(--do-ink)]">
            Nom du dossier
          </span>
          <Input
            ref={inputRef}
            value={name}
            maxLength={80}
            disabled={saving}
            onChange={(event) =>
              setName(event.target.value)
            }
            placeholder="Ex. Commandes clients"
            autoComplete="off"
            data-testid={`${testIdPrefix}-name`}
          />
          <span className="mt-1 block text-right text-xs text-[var(--do-muted)]">
            {name.length}/80
          </span>
        </label>

        <div className="mt-6 grid gap-3 sm:grid-cols-2">
          <Button
            type="button"
            variant="actaSecondary"
            className="min-h-[50px]"
            disabled={saving}
            onClick={onClose}
          >
            Annuler
          </Button>

          <Button
            type="submit"
            variant="actaPrimary"
            className="min-h-[50px]"
            disabled={
              saving
              || !cleanName
              || unchanged
            }
            data-testid={`${testIdPrefix}-confirm`}
          >
            {saving
              ? savingLabel
              : submitLabel}
          </Button>
        </div>
      </form>
    </div>
  );
}
